export default "__VITE_ASSET__DK0Cq0hH__"